import React from "react";
import { DefinitionFilterOutputContainer } from "../../../containers";

const OutputFilter = (props) => {
  return <DefinitionFilterOutputContainer {...props} />;
};

export default OutputFilter;
